import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { useClient, useQueryClient } from "../../ClientContext";
import { PortalClientError } from "../../types";
import { JsonApiResponse } from "../types";
import { CreateUserNotesVariables, UserNote } from "./types";

const useCreateUserNote = (
  options?: UseMutationOptions<
    JsonApiResponse<UserNote>,
    PortalClientError,
    CreateUserNotesVariables
  >
) => {
  const client = useClient();
  const queryClient = useQueryClient();

  return useMutation<
    JsonApiResponse<UserNote>,
    PortalClientError,
    CreateUserNotesVariables
  >(
    (variables) =>
      client.post(`/users/${variables.userId}/notes`, variables.payload),
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(["userNotes", variables.userId]);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};

export default useCreateUserNote;
